import TextInputCounter from './TextInputCounter.view';

export default TextInputCounter;
